import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Graphics } from "constant";

export const Color = {
  blue: { background: "blueButton", font: "white" },
  gray: { background: "grayButton", font: "white" },
  green: { background: "greenButton", font: "white" },
  white: { background: "whiteButton", font: "#238fc1" },
  transparent: { background: "transparent", font: "uiText" },
  facebook: { background: "facebookButton", font: "white"},
  twitter: { background: "twitterButton", font: "white"},
  instagram: { background: "instagramButton", font: "white"},
  line: { background: "lineButton", font: "white"},
  liveChat: { background: "liveChatButton", font: "white"}
};

export const Size = {
  large: { height: 34, padding: 16, font: 1 },
  medium: { height: 24, padding: 8, font: 0.9 },
  small: { height: 20, padding: 6, font: 0.8 },
  "x-small": { height: 16, padding: 4, font: 0.6 }
};

export default class Button extends Component {
  static propTypes = { 
    children: PropTypes.string, 
    width: PropTypes.number, 
    size: PropTypes.oneOf(["large", "medium", "small", "x-small"]), 
    color: PropTypes.oneOf([
      "blue",
      "gray",
      "green",
      "white",
      "transparent"
    ]), 
    border: PropTypes.bool, 
    rounded: PropTypes.bool, 
    disabled: PropTypes.bool, 
    loading: PropTypes.bool, 
    onClick: PropTypes.func, 
    forcedColor: PropTypes.string,
    semiRounded: PropTypes.bool
  };

  static defaultProps = { size: "large", color: "blue", forcedColor: null };

  render() {
    const { loading, children, ...props } = this.props;
    return <Wrapper {...props}>
        {loading && <img alt="loading" src={Graphics.loading} />}
        {children}
      </Wrapper>;
  }
}

const Wrapper = styled.button`
  flex: none;
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  border-radius: 4px;
  white-space: nowrap;
  user-select: none;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
  ${props =>
    props.width &&
    css`
      width: ${props.width}px;
    `};
  ${props =>
    props.border &&
    css`
      border: 1px solid ${props.theme.headerButtonBorder};
    `};
  ${props =>
    props.rounded &&
    css`
      border-radius: ${Size[props.size].height * 0.5}px;
    `};
  ${props => css`
    height: ${Size[props.size].height}px;
    font-size: ${Size[props.size].font}rem;
    padding: 0 ${Size[props.size].padding}px;
    color: ${props.theme[Color[props.color].font]};
    background-color: ${props.theme[Color[props.color].background]};
  `};
  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
      color: ${props.theme[Color.gray.font]};
      background-color: ${props.theme[Color.gray.background]};
    `};
  ${props =>
    props.forcedColor &&
    css`
      color: ${props.theme[Color[props.forcedColor].font]};
      background-color: ${props.theme[Color[props.forcedColor].background]};
      opacity: 1;
    `};
  ${props =>
    props.semiRounded &&
    css`
      border-radius: 4px;
    `};  
`;



// WEBPACK FOOTER //
// ./src/module-common/Button.js